import { Button, Col, Divider, Image, Row, Tabs, Tooltip, Space, Layout, Table, message, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { colorDate, handleTermSlash, extractValueFromUrl, getItemAlt, getListPrice, imageFallback, parseAuthors, parseSubjects, parseSubjectsList, parseAuthorsLink, ucfirst } from "../utils/Utils";
import conditional from "../utils/conditional";
import SalesIndicator from "./SalesIndicator";
import moment from "moment-timezone";
import { useHistory, useLocation, useParams } from "react-router";
import Html from "../utils/Html";
import { useSession } from "../utils/Session";
import { Link } from "react-router-dom";
import { apiCall } from "../utils/Api";
import TitleRank from "./TitleRank";
import Pubstock, { drawOO, drawOOToolTip } from "./Pubstock";
import Peers from "./Peers";
import TitleImage from "./TitleImage";
import ListCount from "./ListCount";
import CatalogueCount from "./CatalogueCount";
import DigitalResources from "./DigitalResources";
import ListQuickPick from "./ListQuickPick";
import CopyButton from "../util_components/CopyButton";
import { CopyFilled, CloseOutlined } from '@ant-design/icons'
import TitleExtras from "./TitleExtras";
import Renderer from "./Renderer";
import Related from "./TitleRelated";
import Comparables from "./TitleRelated";
import TitleRelated from "./TitleRelated";
import TitleLinks from "./TitleLinks";
import TitlePDF from "./TitlePDF";
import TitleShare from "./TitleShare";
import SalesCount from "./SalesCount";
import SeriesCount from "./SeriesCount";

export function TitleTable(props) {

    const [session, setSession] = useSession();
    const [expanded, setExpanded] = useState([]);


    const expandCell = (_data, _type) => {
        if (!expanded.includes(_data.eisbn)) {
            setExpanded([_data.eisbn]);
        } else {
            setExpanded([]);
        }
    }



    const drawChildTable = (_record) => {

        return (
            <>
                <div className="hideHover" style={{ "marginTop": "-7px", "marginLeft": "-8px", "marginRight": "-8px", "maxWidth": "1210px" }}>
                    <div style={{ "padding": "0 0px" }}>
                        <div style={{ "marginTop": "0px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                            <Button style={{ "float": "right" }} onClick={() => setExpanded([])} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                            <br clear="both" />
                        </div>
                    </div>
                    <div style={{ "padding": "10px 0px", "backgroundColor": "#fff" }}>
                        <Renderer record_key={expanded} >
                            {(expanded && <Title divider={false} view={"details"} data={_record} />)}
                        </Renderer>
                    </div>
                </div>
            </>
        )
    }

    const { rows = [] } = props;


    const convertSupplierCode = (_qty = "") => {

        _qty = _qty.trim();
        _qty = _qty.toUpperCase();

        if (_qty === 'T') {
            return "TOS";
        } else if (_qty === 'Y') {
            return "YES";
        } else if (_qty === '+') {
            return "NYR";
        } else if (_qty === "Q") {
            return "Qwk";
        } else if (_qty == "L") {
            return "LOW";
        } else if (_qty === "Z") {
            return "ITO";
        } else if (_qty === "R") {
            return "RP";
        } else if (_qty === "P") {
            return "POD";
        } else if (_qty === "M") {
            return "Mgd";
        } else if (_qty === 'O') {
            return 'BOO';
        }

        return _qty;
    }

    const columns = [

        // {
        //     title: <div style={{ "paddingLeft": "2px" }}><small>ISBN</small></div>, dataIndex: 'isbn', key: 'isbn', render: (e) => {
        //         return (<div style={{ "width": "93px", "textAlign": "center", "paddingLeft": "2px" }} className='overhide'><nobr>{e}</nobr></div>)
        //     }
        // },
        {
            title: <small>Title</small>, dataIndex: 'title', key: 'title', render: (e, f) => {
                return <div className='overhide' style={{ "minWidth": "190px" }} ><a onClick={() => expandCell(f)} style={{ "cursor": "pointer" }}>{e}<div style={{ "opacity": "0.7", "fontSize": "12px" }}>{(f.subtitle) ? f.subtitle : ""}</div></a></div>
            }
        },
        {
            title: <small>Author</small>, style: { "overflow": "hidden" }, dataIndex: 'authors', key: 'authors', render: (e) => {
                return <div className='overhide'>{e.map(item => item.name).join(", ")}</div>
            }
        },
        {
            title: <small>Bd</small>, dataIndex: 'binding_code', key: 'binding_code', render: (e) => {
                return <div className='overhide'>{e}</div>
            }
        },
        // {
        //     title: <small>Price</small>, width: "100px", dataIndex: 'price', key: 'price', render: (e, f) => {


        //         return getListPrice(f.list_price_can, f.list_price_usa, window.sitesettings.is_canadian, true);
        //     }
        // },
        {
            title: <small>PubDate</small>, dataIndex: 'release_date', key: 'release_date', render: (e, f) => {
                return <div className='overhide'><span style={{ whiteSpace: 'nowrap' }} className={colorDate(e, f)}>{moment(e * 1000).format("MMMD-YY")}</span></div>;
            }
        },
        {
            title: <small>Series</small>, dataIndex: 'series', key: 'series', render: (e) => {
                return (<div>{e}</div>)
            }
        },
        {
            title: <small>#</small>, dataIndex: 'series_num', key: 'series_num', render: (e) => {
                return (<div className='overhide'>{e}</div>)
            }
        },
        {
            title: <small>Subjects</small>, dataIndex: 'subjects', key: 'subjects', render: (e) => {
                return (
                    <div className='overhide'>
                        <span>
                            {parseSubjectsList(e, 15)}
                        </span>
                    </div>
                );
            }
        },
        {
            title: <small>Publisher</small>, dataIndex: 'publisher', key: 'publisher', render: (e) => {
                return (<div className='overhide'>{e}</div>)
            }
        },

        {
            title: <small>Rank</small>, dataIndex: 'rank', key: 'rank', render: (e, f) => {
                return (<div style={{ "textAlign": "center", "cursor": "pointer" }} className='overhide'><TitleRank highlight={f.highlight} number_only rank={e} /></div>);
            }
        }


    ]

    if (session?.has_bm_data_full || session?.has_bm_data_lite) {

        columns.push(
            {
                title: <small>ISBN</small>, dataIndex: 'isbn', key: 'isbn'
            }
        )
    }


    if (session.chosen_supplier) {

        columns.splice(1, 0, {
            title: <small>%</small>, className: "cellBorder", dataIndex: 'discount', key: 'discount', render: (e, f) => {
                return (
                    <div style={{ "width": "30px" }} className='overhide'>
                        <span className="c">{(f.hasOwnProperty("supplier_info")) ? f.supplier_info.discount : ""}</span>
                    </div>
                );
            }
        })

        columns.splice(1, 0, {
            title: <small>Price</small>, dataIndex: 'price', key: 'price', render: (e, f) => {
                return (
                    <div style={{ "width": "55px" }} className='overhide'>
                        <span className="c">{(f.hasOwnProperty("supplier_info") && f.supplier_info.price) ? "$" + f.supplier_info.price : ""}</span>
                    </div>
                );
            }
        })

        columns.splice(1, 0, {
            title: <small>{drawOOToolTip("OO")}</small>, dataIndex: 'oo', key: 'oo', render: (e, f) => {
                return (
                    <div style={{ "width": "30px" }} className='overhide'>

                        <Tooltip title={drawOO(convertSupplierCode(f?.supplier_info?.onorder || ""))}> <nobr><span className="c">{(f.hasOwnProperty("supplier_info")) ? convertSupplierCode(f.supplier_info.onorder) : ""}</span></nobr></Tooltip>
                    </div>
                );
            }
        })

        columns.splice(1, 0, {
            title: <small>OH</small>, dataIndex: 'oh', key: 'oh', render: (e, f) => {
                return (
                    <div style={{ "width": "30px" }} className='overhide'>
                        <nobr><span className="c">{(f.hasOwnProperty("supplier_info")) ? convertSupplierCode(f.supplier_info.onhand) : ""}</span></nobr>
                    </div>
                );
            }
        })

    }

    return (
        <div>
            <div style={{ minWidth: 'auto' }}>
                <Table
                    size="small"
                    pagination={false}
                    columns={columns}
                    rowKey={"eisbn"}
                    className="fullTable"
                    dataSource={rows}
                    expandable
                    expandedRowKeys={expanded}
                    expandIconColumnIndex={-1}
                    onExpand={(e) => { return false; }}
                    expandIcon={() => { return (<></>) }}
                    expandedRowRender={((record) => drawChildTable(record))}
                />
            </div>
        </div>
    )
}

export default function Title(props) {

    const { view = "", divider = true, load_id = "" } = props;
    const [session, setSession] = useSession();
    const [underflow, setUnderFlow] = useState("")
    const history = useHistory();
    const loc = useLocation();
    const [loading, setLoading] = useState(false);
    const { item_id = "" } = useParams();
    const [data, setData] = useState((props?.data) ? props.data : (loc?.state) ? loc.state : {});


    const list_id = (props.list_id) ? props.list_id : extractValueFromUrl(window.location.pathname, "list");


    const {
        reviews = [],
        comments = [],
        rank = [],
        subjects = [],
        bio = [],
        authors = [],
        title = "",
        subtitle = "",
        language = "",
        description = "...",
        imprint = "",
        publisher = "",
        illustrations = "",
        edition = "",
        eisbn = "",
        cover_image_cache = "",
        pubstock = null,
        isbn = "",
        titlelist_id = "",
        isbn_type = "",
        upc = "",
        upc_type = "",
        series = "",
        series_num = "",
        print_status = "",
        binding = "",
        pages = "",
        width = "",
        height = "",
        weight = "",
        carton_qty = "",
        media = [{ data: [], type: "" }],
        release_date = null,
        is_forthcoming = false,
        has_libro_audiobook = false,
        list_previous_eisbn = "",
        list_next_eisbn = "",
        audience = "",
        interior_objects = [],
        is_giftcard = false,
        sales_marketing = null,
        cover_image_key = "",
        has_interiors = null,
        last_order = {
            bookorder_id: null,
            date_ordered: null
        },
        catalogue_count = 0,
        my_lists = [],
        digital_resources = [],
        related_count = {},
        peer_sales = false,

    } = data;


    const [myLists, setMyLists] = useState(my_lists);


    const drawNext = () => {
        if (list_next_eisbn) {
            let url = "/item/" + list_next_eisbn + "/list/" + list_id;
            return (<Button onClick={() => history.push(url)}>Next</Button>)
        } else {
            return (<></>);
        }
    }

    const drawPrev = () => {
        if (list_previous_eisbn) {
            let url = "/item/" + list_previous_eisbn + "/list/" + list_id;
            return (<Button onClick={() => history.push(url)}>Previous</Button>)
        } else {
            return (<></>);
        }
    }


    const getItem = () => {
        if (!item_id && !load_id) { return; }

        let _obj = {}
        _obj.eisbn = (item_id) ? item_id : load_id
        if (list_id) {
            _obj.list_id = list_id;
        }

        setLoading(true);
        apiCall("title/getItem", _obj, (_s, _r) => {

            if (_s) {
                setData(_r);
            } else {
                message.error(_r.error)
            }
            setLoading(false)
        })
    }

    useEffect(getItem, [load_id, history.location.pathname]);


    const wrapPublishDate = (_date) => {


        if (data.is_forthcoming) {
            return (<span className={colorDate(data.release_date)}>Releases: {moment(data.release_date * 1000).format('MMM DD, YYYY')}</span>)
        } else {
            return (<span className={colorDate(data.release_date)}>Published: {moment(data.release_date * 1000).format('MMM DD, YYYY')}</span>)
        }
    }





    const linkOut = () => {
        if (list_id) {
            history.push("/item/" + eisbn + "/list/" + list_id)
        } else {
            history.push("/item/" + eisbn)
        }
    }


    const drawSummary = () => {


        const pagesValue = pages != null ? pages + " pages | " : null;
        const widthValue = width && height != null ? width + "\" x " : null;
        const heightValue = width && height != null ? height + "\" | " : null;
        const weightValue = weight != null ? weight + "lbs | " : null;
        const cartonValue = carton_qty != null ? "Crtn: " + carton_qty : null;


        return (
            <Spin spinning={loading}>

                <div className="summary">
                    <div className="title-wrap">
                        <Row gutter={15} style={{ "width": "100%" }} >
                            <Col xs={7} lg={(view === "full") ? 9 : 9} >
                                {!loading && 
                                    <TitleImage
                                    cover_image_cache={cover_image_cache}
                                    interior_objects={interior_objects}
                                    isbn={isbn}
                                    cover_image_key={cover_image_key}
                                    eisbn={eisbn}
                                    has_interiors={has_interiors}
                                    data={data}
                                />
                                }
                                
                              
                                <div className="shim" /><div className="shim" />
                                <div className="hide">
                                    <CopyButton request eisbn={eisbn} buttonProps={{ "size": "small" }} copy_text={isbn} success_text={<small>Copied!</small>} label={<small style={{ display: "flex", justifyContent: "space-between" }}> <span>{isbn}</span><span>Copy</span> </small>} />
                                </div>

                                <div className="shim" />
                                <div style={{ "gap": "5px" }} className="float-flex">
                                    {(session?.logged_in) && <TitlePDF eisbn={eisbn} />}
                                    <TitleShare title={title} isbn={isbn} eisbn={eisbn} />
                                    {((session.has_bm_data_lite || session.has_bm_data_full) && <TitleLinks authors={authors} isbn={isbn} />)}
                                </div>
                                <div className="shim" />
                            </Col>
                            <Col xs={17} lg={15} >
                                <div>

                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            let _term = title;
                                            if (authors.length > 0) { _term += " " + authors[0].name; }
                                            window.open("/browse/filter/v/related:" + isbn + "/t/" + handleTermSlash(_term, true));
                                        }}
                                        className={(view === "full") ? "summary-title-full" : "summary-title"}
                                    >
                                        <Tooltip title={<small>View other editions of this title</small>}><a>{title}</a></Tooltip>
                                        <span>{subtitle}</span>
                                    </div>

                                    <div className="shim" />
                                    <conditional.true value={authors.length > 0}>
                                        <span style={{ "display": "block", "lineHeight": "1.2em" }}>by {parseAuthorsLink(data.authors, session)}<br /></span>
                                    </conditional.true>
                                    <div className="c2" style={{ "fontSize": "14px", "display": "block", "fontWeight": "normal", "marginTop": "-2px" }}><span>{publisher}</span>{(imprint && <em> | {imprint}</em>)}</div>
                                    <span>{(data.is_large_print) ? "Large Print " : ""}{data.binding}</span>
                                    {getListPrice(data.list_price_can, data.list_price_usa, true, false, 600)}
                                    <conditional.true value={series}>
                                        <div><strong>Series: </strong>
                                            <Tooltip title={<small>View other titles in this series</small>}>
                                                <a onClick={() => {
                                                    window.open("/browse/filter/z/" + handleTermSlash(series, true));
                                                }}>{series} {(series_num) ? "#" + series_num : ""}
                                                </a>
                                            </Tooltip>
                                        </div>
                                    </conditional.true>
                                    <conditional.true value={language}>
                                        <div><strong>Language:</strong> {language}</div>
                                    </conditional.true>
                                    {(audience && <span style={{ "fontSize": "14px", "display": "block", "fontWeight": "normal" }}><strong>Audience:</strong> {audience}</span>)}
                                    <div className="shim" />
                                    {parseSubjects(subjects)}
                                    {(data.edition && <div style={{ "fontSize": "12px", "display": "block", "fontWeight": "normal", "marginLeft": "-2px" }}><mark>{data.edition}</mark><div className="shim" /></div>)}

                                    <span style={{ "display": "block", "lineHeight": "16px" }}>
                                        {(data.release_date && wrapPublishDate(data.release_date))}
                                    </span>

                                    <conditional.true value={(!window.sitesettings.hide_sales_rank)}>
                                        <span><TitleRank highlight={false} rank={rank} /></span>
                                    </conditional.true>
                                    {(print_status && <span className="c2" style={{ "color": "#008b7c", "fontSize": "12px", "display": "block", "fontWeight": "normal" }}>{ucfirst(print_status)}</span>)}

                                    {(illustrations && <div style={{ "fontSize": "12px" }}>Illustrations & Content: <span className='c2' style={{ "fontWeight": "normal" }}>{illustrations}</span></div>)}

                                    <span
                                        className="c2"
                                        style={{ "fontSize": "12px", "display": "block", "fontWeight": "normal" }}>
                                        {pagesValue} {widthValue} {heightValue} {weightValue} {cartonValue}
                                    </span>

                                    <div className="show">
                                        <div className="shim"></div><div className="shim"></div>
                                        <CopyButton request eisbn={eisbn} buttonProps={{ "size": "small" }} copy_text={isbn} success_text={<small>Copied!</small>} label={<small style={{ display: "flex", justifyContent: "space-between" }}> <span>{isbn}</span><span>Copy</span> </small>} />
                                    </div>
                                    <div className="shim" /><div className="shim" />
                                    <Space>
                                        <Html html={`<div class="tbm_shop_local" data-options=" { 'api_key' : 'pea0O4sbfjGHbHyOgKLrIGXKhuHzOohR', 'product_code' : '${eisbn}', 'image' : 'https://bookmanager.com/public/api/btns/Shop Local Button.png' }" />`} />

                                    </Space>




                                    <div onClick={e => e.stopPropagation()}><ListQuickPick eisbn={eisbn} my_lists={myLists} updateMyListsInParent={setMyLists} /></div>
                                    <div className="shim" /><div className="shim" />
                                    <Space wrap size={[3, 3]}>
                                        {(session.logged_in && <ListCount title={title} my_lists={myLists} eisbn={eisbn} updateMyListsInParent={setMyLists} />)}
                                        {(catalogue_count > 0 && <CatalogueCount count={catalogue_count} eisbn={eisbn} />)}
                                        {(session?.has_bm_data_full && <SalesCount title={title} data={sales_marketing || {}} />)}
                                        {(digital_resources && <DigitalResources data={digital_resources} />)}
                                        <TitleRelated eisbn={eisbn} related_count={related_count} />

                                        {((series && series_num && binding && (session.has_bm_data_lite || session.has_bm_data_full)) && <>
                                            <SeriesCount setUnderFlow={setUnderFlow} series_num={(series_num) ? ": (#" + series_num.toString() + ")" : ""} series={series} next={true} drawComponent={(e) => { }} isbn={isbn} />
                                            <SeriesCount setUnderFlow={setUnderFlow} series_num={(series_num) ? ": (#" + series_num.toString() + ")" : ""} series={series} next={false} drawComponent={(e) => { }} isbn={isbn} />
                                        </>)}

                                    </Space>

                                </div>
                            </Col>
                        </Row>



                        {((view === "full" || view === "details") && <div style={{ "width": "100%" }}>

                            {(view === "full" &&
                                <div className="float-flex">
                                    <div></div>
                                    <Space>
                                        {drawPrev()}
                                        {drawNext()}
                                        <Button onClick={history.goBack}>Go back</Button>
                                    </Space>
                                </div>
                            )}

                            <Pubstock eisbn={eisbn} suppliers={pubstock} />
                            <div className="shim" /><div className="shim" />
                            {(peer_sales && <Peers data={peer_sales} />)}
                        </div>)}
                    </div>

                    {((view === "details" || view === "full") && <TitleExtras list_id={list_id} titlelist_id={titlelist_id} view={view} data={data} />)}
                    {(divider && <Divider style={{
                                   height: "4px",
                                   backgroundColor: "#ddd",
                                   border: 0,
                               }} />)}

                    {underflow}
                </div>

            </Spin>
        )

    }


    return drawSummary()

}